export const getHttpClientFromFlowAPI = (flowAPI) => ({
  client: flowAPI.httpClient.client,
  cancelTokenSource: flowAPI.httpClient.constructor.CancelToken.source,
  isCancel: flowAPI.httpClient.constructor.isCancel,
});
